
import { useEffect, useState } from "react";
// import {
//   createBrowserRouter,
//   RouterProvider,
//   useSearchParams,
// } from "react-router-dom";

import { useAuth0 } from "@auth0/auth0-react";
import { getCookie, getConfig } from './api';
import { Card } from "react-bootstrap";

import './App.css';
import Spinner from 'react-bootstrap/Spinner';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

import UserInfo from './component/UserInfo';
import Footer from "./component/Footer";
import Header from "./component/Header";
import UserCalendar from "./component/UserCalendar";


// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <UserInfo />

//   },
//   {
//     path: "/calendar",
//     element: <UserCalendar />,
//   },

// ]);


function App() {
  const [calendars, setCalendars] = useState();
  const [loading, setLoading] = useState(true);
  const { isAuthenticated, getIdTokenClaims, user } = useAuth0();
  const [showToast, setShowToast] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');


  useEffect(() => {
    if (isAuthenticated) {
      async function fetchData() {
        // You can await here
        const { __raw: id_token } = await getIdTokenClaims();
        await getCookie(id_token);
        const calendarList = await getConfig(id_token);
        setCalendars(calendarList);
        setLoading(false)
      }
      fetchData();
    }

  }, [isAuthenticated, getIdTokenClaims]);

  const handleMessage = (messageData) => {
    setMessage(messageData.message);
    setMessageType(messageData.type);
    setShowToast(true);
  }

  const getCalenderAfterSave = (cals) => {
    setCalendars(cals);
  }


  return (
    <div className="App">
      <Card>
        <Card.Body>
          <ToastContainer
            className="p-3"
            position="top-center"
            style={{ zIndex: 1 }}
          >
            <Toast onClose={() => setShowToast(false)} show={showToast} autohide bg={messageType === "error" ? "danger" : "info"} >
              <Toast.Body>{message}</Toast.Body>
            </Toast>
          </ToastContainer>
          <Card.Header>
            <Header />
          </Card.Header>
          {isAuthenticated && <div style={{ marginBottom: 20 }}>

            <div className="h3">{calendars ? "Your Calendars" : "Welcome"}</div>
            <div className="h4">{user?.email}</div>

          </div>
          }
          <div className="appBody">

            {isAuthenticated ?
              <>
                {loading ?
                  <Spinner animation="border" role="status" variant="info">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                  : calendars ? <UserCalendar calendars={calendars} handleMessage={handleMessage} /> : <UserInfo handleMessage={handleMessage} getCalenderAfterSave={getCalenderAfterSave} />

                }

              </> : null


            }
          </div>
        </Card.Body>
        <Card.Footer>
          <Footer />
        </Card.Footer>
      </Card>





    </div>
  );
}

export default App;
